<template>
  <g>
    <g transform="scale(0.6)" @click="showDistance">
        <text transform="matrix(1 0 0 1 205 50)" class="name"
            >초음파센서{{ number }}</text
        >
        <polygon
            class="st0"
            points="214.52,323 214.52,270.46 207.98,270.46 207.98,256.5 54.73,256.5 54.73,51.5 480.73,51.5 480.73,256.5 324.98,256.5 324.98,270.46 318,270.46 318,323 "
        />
        <g>
            <rect x="64.73" y="61.5" class="st1" width="406" height="185" />
            <g>
                <circle class="st2" cx="81.73" cy="77.5" r="8" />
                <circle class="st2" cx="81.73" cy="230.5" r="8" />
                <circle class="st2" cx="453.73" cy="77.5" r="8" />
                <circle class="st2" cx="453.73" cy="230.5" r="8" />
            </g>
            <text
                transform="matrix(1 0 0 1 95.3324 238.041)"
                class="st3 st4 st5"
                >T</text
            >
            <text
                transform="matrix(1 0 0 1 224.5824 97.041)"
                class="st3 st4 st6"
                >HC-SR04</text
            >
            <text
                transform="matrix(1 0 0 1 423.3324 238.041)"
                class="st3 st4 st5"
                >R</text
            >
            <text
                transform="matrix(6.123234e-17 -1 1 6.123234e-17 229.3518 224.9067)"
                class="st3 st4 st7"
                >Vcc</text
            >
            <text
                transform="matrix(6.123234e-17 -1 1 6.123234e-17 257.3518 224.9067)"
                class="st3 st4 st7"
                >Trig</text
            >
            <text
                transform="matrix(6.123234e-17 -1 1 6.123234e-17 286.3518 224.9067)"
                class="st3 st4 st7"
                >Echo</text
            >
            <text
                transform="matrix(6.123234e-17 -1 1 6.123234e-17 315.3518 224.9067)"
                class="st3 st4 st7"
                >Gnd</text
            >
        </g>
        <g>
            <g>
                <circle class="st2" cx="374.23" cy="154" r="71.5" />
                <circle class="st8" cx="374.23" cy="154.5" r="57.5" />
                <circle class="st9" cx="374.23" cy="154.5" r="45.5" />
                <circle class="st10" cx="374.23" cy="154.5" r="31.5" />
                <g>
                    <defs>
                        <circle
                            id="SVGID_1_Ultra"
                            cx="374.23"
                            cy="154.5"
                            r="57.5"
                        />
                    </defs>
                    <clipPath id="SVGID_2_Ultra">
                        <use
                            xlink:href="#SVGID_1_Ultra"
                            style="overflow:visible;"
                        />
                    </clipPath>
                    <g class="st11">
                        <line
                            class="st12"
                            x1="301.73"
                            y1="78"
                            x2="301.73"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="305.23"
                            y1="78"
                            x2="305.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="309.23"
                            y1="78"
                            x2="309.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="313.23"
                            y1="78"
                            x2="313.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="317.23"
                            y1="78"
                            x2="317.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="321.23"
                            y1="78"
                            x2="321.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="325.23"
                            y1="78"
                            x2="325.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="329.23"
                            y1="78"
                            x2="329.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="333.23"
                            y1="78"
                            x2="333.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="337.23"
                            y1="78"
                            x2="337.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="341.23"
                            y1="78"
                            x2="341.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="345.23"
                            y1="78"
                            x2="345.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="349.23"
                            y1="78"
                            x2="349.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="353.23"
                            y1="78"
                            x2="353.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="357.23"
                            y1="78"
                            x2="357.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="361.23"
                            y1="78"
                            x2="361.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="365.23"
                            y1="78"
                            x2="365.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="369.23"
                            y1="78"
                            x2="369.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="373.23"
                            y1="78"
                            x2="373.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="377.23"
                            y1="78"
                            x2="377.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="381.23"
                            y1="78"
                            x2="381.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="385.23"
                            y1="78"
                            x2="385.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="389.23"
                            y1="78"
                            x2="389.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="393.23"
                            y1="78"
                            x2="393.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="397.23"
                            y1="78"
                            x2="397.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="401.23"
                            y1="78"
                            x2="401.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="405.23"
                            y1="78"
                            x2="405.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="409.23"
                            y1="78"
                            x2="409.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="413.23"
                            y1="78"
                            x2="413.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="417.23"
                            y1="78"
                            x2="417.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="421.23"
                            y1="78"
                            x2="421.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="425.23"
                            y1="78"
                            x2="425.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="429.23"
                            y1="78"
                            x2="429.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="433.23"
                            y1="78"
                            x2="433.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="437.23"
                            y1="78"
                            x2="437.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="441.23"
                            y1="78"
                            x2="441.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="445.23"
                            y1="78"
                            x2="445.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="449.23"
                            y1="78"
                            x2="449.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="453.23"
                            y1="78"
                            x2="453.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="84.25"
                            x2="294.48"
                            y2="84.25"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="87.75"
                            x2="294.48"
                            y2="87.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="91.75"
                            x2="294.48"
                            y2="91.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="95.75"
                            x2="294.48"
                            y2="95.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="99.75"
                            x2="294.48"
                            y2="99.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="103.75"
                            x2="294.48"
                            y2="103.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="107.75"
                            x2="294.48"
                            y2="107.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="111.75"
                            x2="294.48"
                            y2="111.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="115.75"
                            x2="294.48"
                            y2="115.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="119.75"
                            x2="294.48"
                            y2="119.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="123.75"
                            x2="294.48"
                            y2="123.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="127.75"
                            x2="294.48"
                            y2="127.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="131.75"
                            x2="294.48"
                            y2="131.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="135.75"
                            x2="294.48"
                            y2="135.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="139.75"
                            x2="294.48"
                            y2="139.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="143.75"
                            x2="294.48"
                            y2="143.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="147.75"
                            x2="294.48"
                            y2="147.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="151.75"
                            x2="294.48"
                            y2="151.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="155.75"
                            x2="294.48"
                            y2="155.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="159.75"
                            x2="294.48"
                            y2="159.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="163.75"
                            x2="294.48"
                            y2="163.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="167.75"
                            x2="294.48"
                            y2="167.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="171.75"
                            x2="294.48"
                            y2="171.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="175.75"
                            x2="294.48"
                            y2="175.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="179.75"
                            x2="294.48"
                            y2="179.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="183.75"
                            x2="294.48"
                            y2="183.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="187.75"
                            x2="294.48"
                            y2="187.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="191.75"
                            x2="294.48"
                            y2="191.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="195.75"
                            x2="294.48"
                            y2="195.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="199.75"
                            x2="294.48"
                            y2="199.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="203.75"
                            x2="294.48"
                            y2="203.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="207.75"
                            x2="294.48"
                            y2="207.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="211.75"
                            x2="294.48"
                            y2="211.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="215.75"
                            x2="294.48"
                            y2="215.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="219.75"
                            x2="294.48"
                            y2="219.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="223.75"
                            x2="294.48"
                            y2="223.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="227.75"
                            x2="294.48"
                            y2="227.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="231.75"
                            x2="294.48"
                            y2="231.75"
                        />
                        <line
                            class="st12"
                            x1="460.48"
                            y1="235.75"
                            x2="294.48"
                            y2="235.75"
                        />
                    </g>
                </g>
            </g>
            <g>
                <circle class="st2" cx="161.23" cy="154.5" r="71.5" />
                <circle class="st8" cx="161.23" cy="154.5" r="57.5" />
                <circle class="st9" cx="161.23" cy="154.5" r="45.5" />
                <circle class="st10" cx="161.23" cy="154.5" r="31.5" />
                <g>
                    <defs>
                        <circle
                            id="SVGID_3_Ultra"
                            cx="161.23"
                            cy="154.5"
                            r="57.5"
                        />
                    </defs>
                    <clipPath id="SVGID_4_Ultra">
                        <use
                            xlink:href="#SVGID_3_Ultra"
                            style="overflow:visible;"
                        />
                    </clipPath>
                    <g class="st13">
                        <line
                            class="st12"
                            x1="88.73"
                            y1="78"
                            x2="88.73"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="92.23"
                            y1="78"
                            x2="92.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="96.23"
                            y1="78"
                            x2="96.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="100.23"
                            y1="78"
                            x2="100.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="104.23"
                            y1="78"
                            x2="104.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="108.23"
                            y1="78"
                            x2="108.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="112.23"
                            y1="78"
                            x2="112.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="116.23"
                            y1="78"
                            x2="116.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="120.23"
                            y1="78"
                            x2="120.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="124.23"
                            y1="78"
                            x2="124.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="128.23"
                            y1="78"
                            x2="128.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="132.23"
                            y1="78"
                            x2="132.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="136.23"
                            y1="78"
                            x2="136.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="140.23"
                            y1="78"
                            x2="140.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="144.23"
                            y1="78"
                            x2="144.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="148.23"
                            y1="78"
                            x2="148.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="152.23"
                            y1="78"
                            x2="152.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="156.23"
                            y1="78"
                            x2="156.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="160.23"
                            y1="78"
                            x2="160.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="164.23"
                            y1="78"
                            x2="164.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="168.23"
                            y1="78"
                            x2="168.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="172.23"
                            y1="78"
                            x2="172.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="176.23"
                            y1="78"
                            x2="176.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="180.23"
                            y1="78"
                            x2="180.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="184.23"
                            y1="78"
                            x2="184.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="188.23"
                            y1="78"
                            x2="188.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="192.23"
                            y1="78"
                            x2="192.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="196.23"
                            y1="78"
                            x2="196.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="200.23"
                            y1="78"
                            x2="200.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="204.23"
                            y1="78"
                            x2="204.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="208.23"
                            y1="78"
                            x2="208.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="212.23"
                            y1="78"
                            x2="212.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="216.23"
                            y1="78"
                            x2="216.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="220.23"
                            y1="78"
                            x2="220.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="224.23"
                            y1="78"
                            x2="224.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="228.23"
                            y1="78"
                            x2="228.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="232.23"
                            y1="78"
                            x2="232.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="236.23"
                            y1="78"
                            x2="236.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="240.23"
                            y1="78"
                            x2="240.23"
                            y2="244"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="84.25"
                            x2="81.48"
                            y2="84.25"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="87.75"
                            x2="81.48"
                            y2="87.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="91.75"
                            x2="81.48"
                            y2="91.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="95.75"
                            x2="81.48"
                            y2="95.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="99.75"
                            x2="81.48"
                            y2="99.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="103.75"
                            x2="81.48"
                            y2="103.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="107.75"
                            x2="81.48"
                            y2="107.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="111.75"
                            x2="81.48"
                            y2="111.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="115.75"
                            x2="81.48"
                            y2="115.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="119.75"
                            x2="81.48"
                            y2="119.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="123.75"
                            x2="81.48"
                            y2="123.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="127.75"
                            x2="81.48"
                            y2="127.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="131.75"
                            x2="81.48"
                            y2="131.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="135.75"
                            x2="81.48"
                            y2="135.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="139.75"
                            x2="81.48"
                            y2="139.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="143.75"
                            x2="81.48"
                            y2="143.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="147.75"
                            x2="81.48"
                            y2="147.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="151.75"
                            x2="81.48"
                            y2="151.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="155.75"
                            x2="81.48"
                            y2="155.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="159.75"
                            x2="81.48"
                            y2="159.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="163.75"
                            x2="81.48"
                            y2="163.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="167.75"
                            x2="81.48"
                            y2="167.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="171.75"
                            x2="81.48"
                            y2="171.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="175.75"
                            x2="81.48"
                            y2="175.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="179.75"
                            x2="81.48"
                            y2="179.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="183.75"
                            x2="81.48"
                            y2="183.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="187.75"
                            x2="81.48"
                            y2="187.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="191.75"
                            x2="81.48"
                            y2="191.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="195.75"
                            x2="81.48"
                            y2="195.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="199.75"
                            x2="81.48"
                            y2="199.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="203.75"
                            x2="81.48"
                            y2="203.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="207.75"
                            x2="81.48"
                            y2="207.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="211.75"
                            x2="81.48"
                            y2="211.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="215.75"
                            x2="81.48"
                            y2="215.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="219.75"
                            x2="81.48"
                            y2="219.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="223.75"
                            x2="81.48"
                            y2="223.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="227.75"
                            x2="81.48"
                            y2="227.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="231.75"
                            x2="81.48"
                            y2="231.75"
                        />
                        <line
                            class="st12"
                            x1="247.48"
                            y1="235.75"
                            x2="81.48"
                            y2="235.75"
                        />
                    </g>
                </g>
            </g>
        </g>
        <g>
            <g style="transform: translate(-6px,0)">
                <g>
                    <defs>
                        <path
                            id="SVGID_5_Ultra"
                            d="M224.52,253.41v55.15c0,2.45,1.99,4.44,4.44,4.44c2.45,0,4.44-1.99,4.44-4.44v-55.15
                        c0-2.45-1.99-4.44-4.44-4.44C226.51,248.97,224.52,250.96,224.52,253.41"
                        />
                    </defs>
                    <clipPath id="SVGID_6_Ultra">
                        <use
                            xlink:href="#SVGID_5_Ultra"
                            style="overflow:visible;"
                        />
                    </clipPath>
                    <linearGradient
                        id="SVGID_7_Ultra"
                        gradientUnits="userSpaceOnUse"
                        x1="584.4869"
                        y1="993.8887"
                        x2="585.4497"
                        y2="993.8887"
                        gradientTransform="matrix(9.2244 0 0 -9.2244 -5167.0439 9449.0459)"
                    >
                        <stop offset="0" style="stop-color:#FFFFFF" />
                        <stop
                            offset="1.868181e-08"
                            style="stop-color:#EDEDED"
                        />
                        <stop
                            offset="5.778537e-08"
                            style="stop-color:#CECECE"
                        />
                        <stop
                            offset="1.020836e-07"
                            style="stop-color:#B2B2B2"
                        />
                        <stop
                            offset="1.521744e-07"
                            style="stop-color:#9C9C9C"
                        />
                        <stop
                            offset="2.106338e-07"
                            style="stop-color:#8B8B8B"
                        />
                        <stop
                            offset="2.829549e-07"
                            style="stop-color:#808080"
                        />
                        <stop
                            offset="3.843946e-07"
                            style="stop-color:#797979"
                        />
                        <stop
                            offset="6.659740e-07"
                            style="stop-color:#777777"
                        />
                        <stop offset="0.1253" style="stop-color:#848484" />
                        <stop offset="0.4162" style="stop-color:#9F9FA0" />
                        <stop offset="0.6113" style="stop-color:#9C9C9D" />
                        <stop offset="0.7532" style="stop-color:#939394" />
                        <stop offset="0.8778" style="stop-color:#848384" />
                        <stop offset="0.9926" style="stop-color:#6F6E6E" />
                        <stop offset="1" style="stop-color:#6D6C6C" />
                    </linearGradient>
                    <g class="pin">
                        <rect
                            x="224.52"
                            y="248.97"
                            class="st14"
                            width="8.88"
                            height="64.03"
                        />
                        <rect
                            :id="`${pincode}PS`"
                            @click="onClick(`${pincode}PS`)"
                            class="pin-cover terminal snap"
                            x="222.53"
                            y="300.97"
                            width="15"
                            height="15"
                        ></rect>
                    </g>
                </g>
                <rect
                    x="217.98"
                    y="231"
                    class="st15"
                    width="22"
                    height="29.46"
                />
            </g>
            <g>
                <g>
                    <defs>
                        <path
                            id="SVGID_8_Ultra"
                            d="M249.32,253.41v55.15c0,2.45,1.99,4.44,4.44,4.44c2.45,0,4.44-1.99,4.44-4.44v-55.15
                        c0-2.45-1.99-4.44-4.44-4.44C251.31,248.97,249.32,250.96,249.32,253.41"
                        />
                    </defs>
                    <clipPath id="SVGID_9_Ultra">
                        <use
                            xlink:href="#SVGID_8_Ultra"
                            style="overflow:visible;"
                        />
                    </clipPath>
                    <linearGradient
                        id="SVGID_10_Ultra"
                        gradientUnits="userSpaceOnUse"
                        x1="587.1758"
                        y1="993.8887"
                        x2="588.1385"
                        y2="993.8887"
                        gradientTransform="matrix(9.2244 0 0 -9.2244 -5167.0439 9449.0459)"
                    >
                        <stop offset="0" style="stop-color:#FFFFFF" />
                        <stop
                            offset="1.868181e-08"
                            style="stop-color:#EDEDED"
                        />
                        <stop
                            offset="5.778537e-08"
                            style="stop-color:#CECECE"
                        />
                        <stop
                            offset="1.020836e-07"
                            style="stop-color:#B2B2B2"
                        />
                        <stop
                            offset="1.521744e-07"
                            style="stop-color:#9C9C9C"
                        />
                        <stop
                            offset="2.106338e-07"
                            style="stop-color:#8B8B8B"
                        />
                        <stop
                            offset="2.829549e-07"
                            style="stop-color:#808080"
                        />
                        <stop
                            offset="3.843946e-07"
                            style="stop-color:#797979"
                        />
                        <stop
                            offset="6.659740e-07"
                            style="stop-color:#777777"
                        />
                        <stop offset="0.1253" style="stop-color:#848484" />
                        <stop offset="0.4162" style="stop-color:#9F9FA0" />
                        <stop offset="0.6113" style="stop-color:#9C9C9D" />
                        <stop offset="0.7532" style="stop-color:#939394" />
                        <stop offset="0.8778" style="stop-color:#848384" />
                        <stop offset="0.9926" style="stop-color:#6F6E6E" />
                        <stop offset="1" style="stop-color:#6D6C6C" />
                    </linearGradient>
                    <g class="pin">
                        <rect
                            x="249.32"
                            y="248.97"
                            class="st16"
                            width="8.88"
                            height="64.03"
                        />
                        <rect
                            :id="`${pincode}TR`"
                            @click="onClick(`${pincode}TR`)"
                            class="pin-cover terminal snap"
                            x="247.53"
                            y="300.97"
                            width="15"
                            height="15"
                        ></rect>
                    </g>
                </g>
                <rect
                    x="242.98"
                    y="231"
                    class="st15"
                    width="22"
                    height="29.46"
                />
            </g>
            <g style="transform: translate(5px,0)">
                <g>
                    <defs>
                        <path
                            id="SVGID_11_Ultra"
                            d="M274.12,253.41v55.15c0,2.45,1.99,4.44,4.44,4.44c2.45,0,4.44-1.99,4.44-4.44v-55.15
                        c0-2.45-1.99-4.44-4.44-4.44C276.11,248.97,274.12,250.96,274.12,253.41"
                        />
                    </defs>
                    <clipPath id="SVGID_12_Ultra">
                        <use
                            xlink:href="#SVGID_11_Ultra"
                            style="overflow:visible;"
                        />
                    </clipPath>
                    <linearGradient
                        id="SVGID_13_Ultra"
                        gradientUnits="userSpaceOnUse"
                        x1="589.8647"
                        y1="993.8887"
                        x2="590.8275"
                        y2="993.8887"
                        gradientTransform="matrix(9.2244 0 0 -9.2244 -5167.0439 9449.0459)"
                    >
                        <stop offset="0" style="stop-color:#FFFFFF" />
                        <stop
                            offset="1.868181e-08"
                            style="stop-color:#EDEDED"
                        />
                        <stop
                            offset="5.778537e-08"
                            style="stop-color:#CECECE"
                        />
                        <stop
                            offset="1.020836e-07"
                            style="stop-color:#B2B2B2"
                        />
                        <stop
                            offset="1.521744e-07"
                            style="stop-color:#9C9C9C"
                        />
                        <stop
                            offset="2.106338e-07"
                            style="stop-color:#8B8B8B"
                        />
                        <stop
                            offset="2.829549e-07"
                            style="stop-color:#808080"
                        />
                        <stop
                            offset="3.843946e-07"
                            style="stop-color:#797979"
                        />
                        <stop
                            offset="6.659740e-07"
                            style="stop-color:#777777"
                        />
                        <stop offset="0.1253" style="stop-color:#848484" />
                        <stop offset="0.4162" style="stop-color:#9F9FA0" />
                        <stop offset="0.6113" style="stop-color:#9C9C9D" />
                        <stop offset="0.7532" style="stop-color:#939394" />
                        <stop offset="0.8778" style="stop-color:#848384" />
                        <stop offset="0.9926" style="stop-color:#6F6E6E" />
                        <stop offset="1" style="stop-color:#6D6C6C" />
                    </linearGradient>
                    <g class="pin">
                        <rect
                            x="274.12"
                            y="248.97"
                            class="st17"
                            width="8.88"
                            height="64.03"
                        />
                        <rect
                            :id="`${pincode}EC`"
                            @click="onClick(`${pincode}EC`)"
                            class="pin-cover terminal snap"
                            x="272.53"
                            y="300.97"
                            width="15"
                            height="15"
                        ></rect>
                    </g>
                </g>
                <rect
                    x="267.98"
                    y="231"
                    class="st15"
                    width="22"
                    height="29.46"
                />
            </g>
            <g style="transform: translate(9px,0)">
                <g>
                    <defs>
                        <path
                            id="SVGID_14_Ultra"
                            d="M299.12,253.41v55.15c0,2.45,1.99,4.44,4.44,4.44c2.45,0,4.44-1.99,4.44-4.44v-55.15
                        c0-2.45-1.99-4.44-4.44-4.44C301.11,248.97,299.12,250.96,299.12,253.41"
                        />
                    </defs>
                    <clipPath id="SVGID_15_Ultra">
                        <use
                            xlink:href="#SVGID_14_Ultra"
                            style="overflow:visible;"
                        />
                    </clipPath>
                    <linearGradient
                        id="SVGID_16_Ultra"
                        gradientUnits="userSpaceOnUse"
                        x1="592.5749"
                        y1="993.8887"
                        x2="593.5376"
                        y2="993.8887"
                        gradientTransform="matrix(9.2244 0 0 -9.2244 -5167.0439 9449.0459)"
                    >
                        <stop offset="0" style="stop-color:#FFFFFF" />
                        <stop
                            offset="1.868181e-08"
                            style="stop-color:#EDEDED"
                        />
                        <stop
                            offset="5.778537e-08"
                            style="stop-color:#CECECE"
                        />
                        <stop
                            offset="1.020836e-07"
                            style="stop-color:#B2B2B2"
                        />
                        <stop
                            offset="1.521744e-07"
                            style="stop-color:#9C9C9C"
                        />
                        <stop
                            offset="2.106338e-07"
                            style="stop-color:#8B8B8B"
                        />
                        <stop
                            offset="2.829549e-07"
                            style="stop-color:#808080"
                        />
                        <stop
                            offset="3.843946e-07"
                            style="stop-color:#797979"
                        />
                        <stop
                            offset="6.659740e-07"
                            style="stop-color:#777777"
                        />
                        <stop offset="0.1253" style="stop-color:#848484" />
                        <stop offset="0.4162" style="stop-color:#9F9FA0" />
                        <stop offset="0.6113" style="stop-color:#9C9C9D" />
                        <stop offset="0.7532" style="stop-color:#939394" />
                        <stop offset="0.8778" style="stop-color:#848384" />
                        <stop offset="0.9926" style="stop-color:#6F6E6E" />
                        <stop offset="1" style="stop-color:#6D6C6C" />
                    </linearGradient>
                    <g class="pin">
                        <rect
                            x="299.12"
                            y="248.97"
                            class="st18"
                            width="8.88"
                            height="64.03"
                        />
                        <rect
                            :id="`${pincode}MS`"
                            @click="onClick(`${pincode}MS`)"
                            class="pin-cover terminal snap"
                            x="297.53"
                            y="300.97"
                            width="15"
                            height="15"
                        ></rect>
                    </g>
                </g>
                <rect
                    x="292.98"
                    y="231"
                    class="st15"
                    width="22"
                    height="29.46"
                />
            </g>
        </g>
        <g>
            <g id="distance">
                <path
                    id="distance-area"
                    style="transform: translate(0px, 100px) rotate(-90deg)"
                    :class="{ 'dist-st1': on, 'dist-st0': !on }"
                    d="M448,264c0-61.54-12.13-121.43-36.05-177.99c-6.17-14.58-13.05-28.76-20.62-42.51L94.31,209.04
                C103.04,225.43,108,244.13,108,264s-4.96,38.57-13.69,54.96L391.33,484.5c7.57-13.75,14.45-27.92,20.62-42.51
                C435.87,385.43,448,325.54,448,264z"
                />
                <g
                  v-if="!$store.state.sim.userData[namecode]"
                  class="distance-picker">
                    <text
                      transform="matrix(1 0 0 1 230 -190)"
                      :class="{ 'st15 st21 st5': on, 'dist-st0': !on }"
                    >
                      {{
                          distance === 0 ? "클릭하여 드래그" : distance + "cm"
                      }}</text
                    >
                    <circle
                      :class="{ st19: on, 'dist-st0': !on }"
                      cx="270"
                      cy="-150"
                      r="31.5"
                    />
                </g>
                <g
                  v-if="on && $store.state.sim.userData[namecode]"
                  class="obstacle">
                   <text
                      :transform="`matrix(1 0 0 1 230 ${-100-(value * 3)})`"
                      class="st15 st21 st5"
                    > {{ value }}cm</text>
                    <circle
                      class="st19"
                      cx="270"
                      :cy="-50-(value * 3)"
                      r="31.5"
                    />
                </g>
            </g>
        </g>
    </g>
  </g>
</template>

<script>
import Vue from 'vue'
import store from '../../../../store'
import { pins } from '../../../../mixins/pin-util.js'

const map = function (val, a, b, c, d) {
  return ((val - a) / (b - a)) * (d - c) + c
}

const calDistance = function (coord) {
  const origin = {
    x: -7,
    y: 124
  }
  const dist =
    (origin.x - coord.x) * (origin.x - coord.x) +
    (origin.y - coord.y) * (origin.y - coord.y)
  return Math.round(dist) / 100
}

var vm = new Vue({
  socket: null,
  data: {
    dist: 0,
    x: 0,
    y: 0
  }
})
export default {
  props: ['data'],
  mixins: [pins],
  data () {
    return {
      draggable: null,
      on: false,
      socket: null,
      value: 0, // distance
      mouse: {
        x: 0,
        y: 0
      }
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  computed: {
    distance () {
      return vm.dist
    }
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    start (socket) {
      this.on = true
      if (this.$store.state.sim.userData[this.namecode]) {
        this.socket = socket
        this.socket.onmessage = ({ data }) => {
          data = JSON.parse(data)
          this.value = Math.round(map(data.value, 0, 1023, 0, 80) * 100) / 100
          console.log('distance :', this.value)
        }
      } else {
        vm.socket = socket
        this.showDistance()
      }
    },
    startWithInterval (value) {
      this.on = true
    },
    off () {
      vm.socket = null
      this.on = false
      window.Draggable.get(`#${this.data.id}`).enable()
    },
    showDistance () {
      if (this.on) {
        window.Draggable.get(`#${this.data.id}`).disable()
        var id = this.data.id
        this.draggable = window.Draggable.create(`#${id} .distance-picker`, {
          bounds: `#${id} #distance`,
          onDragEnd: function () {
            if (this.hitTest(`#${id} #distance-area`, '10%')) {
              document.querySelector(`#${id} .distance-picker circle`).classList.add('st20')
              vm.dist = calDistance({ x: this.x, y: this.y })
              store.commit('socket/sendMessage', { socket: vm.socket, message: { value: vm.dist } })
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
polygon.st0 {
    display: none;
}
.pin-cover {
    display: block;
    stroke: none;
    fill: none;
}
.pin:hover {
    cursor: pointer;
    .pin-cover {
        stroke-width: 3px;
        stroke: black;
        fill: #ff6f61;
    }
}
.selected {
    & rect.st1 {
        display: block;
        stroke-width: 4px;
        stroke: #ff6f61;
    }
}
.name {
    font-size: 26px;
}
.st0 {
    fill: #d6d6d6;
}
.st1 {
    fill: #274c76;
}
.st2 {
    fill: #d2d2d0;
}
.st3 {
    fill: #ffffff;
}
.st4 {
    font-family: "MyriadPro-Regular";
}
.st5 {
    font-size: 30px;
}
.st6 {
    font-size: 24px;
}
.st7 {
    font-size: 18px;
}
.st8 {
    fill: #3d4246;
}
.st9 {
    fill: #5e602d;
}
.st10 {
    fill: #b3b3b3;
}
.st11 {
    clip-path: url(#SVGID_2_Ultra);
}
.st12 {
    fill: none;
    stroke: #000000;
    stroke-miterlimit: 10;
}
.st13 {
    clip-path: url(#SVGID_4_Ultra);
}
.st14 {
    clip-path: url(#SVGID_6_Ultra);
    fill: url(#SVGID_7_Ultra);
}
.st15 {
    fill: #333333;
}
.st16 {
    clip-path: url(#SVGID_9_Ultra);
    fill: url(#SVGID_10_Ultra);
}
.st17 {
    clip-path: url(#SVGID_12_Ultra);
    fill: url(#SVGID_13_Ultra);
}
.st18 {
    clip-path: url(#SVGID_15_Ultra);
    fill: url(#SVGID_16_Ultra);
}
.st19 {
    fill: cyan;
}
.st20 {
    fill: #ff6f61;
}
.st21 {
    font-family: "Noto Sans KR", sans-serif;
}
.dist-st0 {
    display: none;
    fill: none;
}
.dist-st1 {
    display: block;
    fill: #e3e3e8;
}
</style>
